import type { TokenPairDto } from "../contracts/model/tokenPairDto";
import type { FetcherConfig } from "./http";
import { authService } from "../../entities/user";

export const loadAuthTokens = (): Promise<TokenPairDto | null> =>
  authService.loadTokens();

export const getCurrentTokens = (): TokenPairDto | null =>
  authService.getTokens();

export const clearAuthTokens = (): Promise<void> => authService.clearTokens();

export const getAuthorizedRequestConfig = (): FetcherConfig =>
  authService.getFetcherConfig();

/**
 * Get authorized request config with wallet ID support.
 * Use this for phone number API endpoints that require X-Wallet-Id header.
 */
export const getAuthorizedRequestConfigWithWallet = (
  getWalletId: () => string | undefined | Promise<string | undefined>,
): FetcherConfig => ({
  ...authService.getFetcherConfig(),
  getWalletId,
});

export const setAuthApiBaseUrl = (url: string) => {
  authService.setApiBaseUrl(url);
};

export const getAuthApiBaseUrl = () => authService.getApiBaseUrl();

export const signInWithTelegram = () => authService.signInFromTelegram();

export const signInWithInitData = (initData: string) =>
  authService.signInWithInitData(initData);

export const refreshAuthTokens = (refreshToken?: string) =>
  authService.refreshTokens(refreshToken).then(result => {
    if (!result.refreshed) {
      throw new Error('Refresh token is missing');
    }
    return result.tokens!;
  });

export const logout = (options?: { skipServer?: boolean }) =>
  authService.logout(options);

